<template>
  <ClientOnly>
    <div v-if="isVisible" class="cookie-notification">
      <div class="cookie-notification__content">
        <p class="cookie-notification__text">
          En Geotur valoramos tu privacidad, te informamos que esta web no utiliza cookies.
        </p>
        <Button @click="handleAccept" variant="primary" size="md">
          Aceptar
        </Button>
      </div>
    </div>
  </ClientOnly>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const STORAGE_KEY = 'geotur-cookies-accepted'
const isVisible = ref(false)

const checkStorage = () => {
  if (typeof window !== 'undefined') {
    const accepted = localStorage.getItem(STORAGE_KEY)
    isVisible.value = !accepted
  }
}

const handleAccept = () => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, 'true')
    isVisible.value = false
  }
}

onMounted(() => {
  checkStorage()
})
</script>

<style scoped>
.cookie-notification {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: var(--color-neutral-900);
  padding: var(--gap-sm);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
}

.cookie-notification__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--gap-sm);
  max-width: var(--content-width);
  margin: 0 auto;
}

.cookie-notification__text {
  color: var(--color-neutral-200);
  font-size: 1.4rem;
  margin: 0;
  flex: 1;
}

@media (max-width: 767px) {
  .cookie-notification__content {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }

  .cookie-notification__text {
    font-size: 1.2rem;
  }
}
</style>

